import React, {useState} from 'react';
import {resource} from '@albert-io/json-api-framework/request/builder';
import {MandarkTable, Button, NoDataMsg, LoadingSpinner} from '@albert-io/atomic';
import {Link} from 'react-router';
import {renderMoment} from 'lib/timeUtils';
import masqueradeStore from 'generic/Masquerade/Masquerade.store';
import useMandarkQueries from 'lib/hooks/useMandarkQueries';
import DeleteDraftModal from './DeleteDraftModal.react';

import './assignment-drafts.scss';

const getDraftListQuery = () => {
  return resource('draft_assignment_v1').mandarkEndpoint(['draft_assignments_v1']).filter({
    teacher_v1: masqueradeStore.getUserIdByMasqueradeState()
  });
};

const getSearchFilters = (query, term) => {
  return query.filter({
    name: {
      case_insensitive_substring: term
    }
  });
};

const AssignmentDrafts = () => {
  const [draftToDelete, setDraftToDelete] = useState(null);

  const {
    isReady,
    resources: [draftRecords]
  } = useMandarkQueries([getDraftListQuery()]);

  if (!isReady) {
    return <LoadingSpinner size={3} />;
  }

  return (
    <>
      {draftRecords.size > 0 ? (
        <div className='assignment-drafts__table'>
          <MandarkTable
            query={getDraftListQuery()}
            searchFilters={getSearchFilters}
            searchPlaceholder='Search'
            defaultSortDirection='DESCENDING'
            persistSearch
            persistPage
            theme='data'
            title='Drafts'
            buttonGroup={[
              <Button as={Link} to='/assignment-builder/create-assignment'>
                Create Assignment
              </Button>
            ]}
          >
            <MandarkTable.Column
              heading='Assignment Name'
              sortBy='name'
              content={(draft) => draft.getName()}
            />
            <MandarkTable.Column
              defaultSortParam
              heading='Last Modified'
              sortBy='last_question_set_inserted_at'
              content={(draft) => renderMoment(draft.getLastQuestionSetInsertedAt(), 'dateFormal')}
            />
            <MandarkTable.Column
              align='right'
              content={(draft) => (
                <>
                  <Button
                    as={Link}
                    variant='outlined'
                    className='assignment-drafts__button-actions u-mar-r_1'
                    to={`/assignment-builder/create-assignment?draftId=${draft.getId()}`}
                  >
                    View
                  </Button>
                  <Button
                    color='destructive'
                    variant='outlined'
                    onClick={() => setDraftToDelete(draft)}
                    className='assignment-drafts__button-actions'
                  >
                    Delete
                  </Button>
                </>
              )}
            />
          </MandarkTable>
          {draftToDelete && (
            <DeleteDraftModal draft={draftToDelete} handleClose={() => setDraftToDelete(null)} />
          )}
        </div>
      ) : (
        <DraftsEmptyState />
      )}
    </>
  );
};

const DraftsEmptyState = () => {
  return (
    <NoDataMsg.Container centered className='folders-list--empty'>
      <NoDataMsg.Heading>No Drafts</NoDataMsg.Heading>
      <NoDataMsg.Body className='u-mar-b_4'>
        Your assignment drafts will appear here.
      </NoDataMsg.Body>
      <Button as={Link} to='/assignment-builder/create-assignment'>
        Create Assignment
      </Button>
    </NoDataMsg.Container>
  );
};

export default AssignmentDrafts;
